import React from "react";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { SERVICES } from "@/data/services";
import { API_BASE } from "@/lib/api";

const META = SERVICES.reduce((acc, s) => { acc[s.id] = s; return acc; }, {});

export const Services = ({ onQuote }) => {
  const { lang, tr } = useLang();
  const { content } = useContent();
  const kn = lang === "kn";

  return (
    <section id="services" className="py-16 lg:py-24 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className={`text-xs font-bold uppercase tracking-widest text-amber-700 ${kn ? "font-kn" : ""}`}>{tr("services_kicker")}</p>
          <h2 className={`mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 ${kn ? "font-kn" : "font-heading"}`}>{tr("services_title")}</h2>
          <p className={`mt-3 text-base text-slate-600 ${kn ? "font-kn" : ""}`}>{tr("services_sub")}</p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {content.services.map((s, i) => {
            const meta = META[s.id] || {};
            const Icon = Icons[meta.icon] || Icons.Sparkles;
            const img = s.image_id ? `${API_BASE}/content/image/${s.image_id}` : meta.img;
            return (
              <div
                key={s.id || i}
                data-testid={`service-card-${s.id}`}
                className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition-all hover:-translate-y-1 hover:shadow-xl hover:border-primary/40 cp-fade-up"
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <div className="relative h-40 overflow-hidden">
                  <img src={img} alt={s.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <span className="absolute left-3 top-3 grid h-9 w-9 place-items-center rounded-lg bg-white/95 text-primary shadow">
                    <Icon size={18} />
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className={`text-lg font-bold text-slate-900 ${kn ? "font-kn" : "font-heading"}`}>{kn && meta.name_kn ? meta.name_kn : s.name}</h3>
                  <p className={`mt-2 flex-1 text-sm leading-relaxed text-slate-600 ${kn ? "font-kn" : ""}`}>{kn && meta.desc_kn ? meta.desc_kn : s.desc}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-sm font-bold text-primary">{kn && meta.price_kn ? meta.price_kn : s.price}</span>
                    <button
                      data-testid={`service-quote-${s.id}`}
                      onClick={() => onQuote?.(s.id)}
                      className="inline-flex items-center gap-1 text-sm font-semibold text-slate-700 hover:text-primary transition-colors"
                    >
                      {tr("get_quote")} <ArrowRight size={15} />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
